import { GUEST_LANGUAGE_COOKIE_NAME } from '../stores/LanguageStore';

const getDefaultExpirationDate = () => {
  const expirationDate = new Date();
  expirationDate.setFullYear(new Date().getFullYear() + 1);
  return expirationDate.toUTCString();
};

const CookieApi = {
  getCookieValue(name: string): string | null {
    const pair = document.cookie.match(new RegExp(`${name}=([^;]+)`));
    if (!!pair) {
      return pair[1];
    }
    return null;
  },

  hasPreferencesCookieConsent(): boolean {
    const consents = this.getCookieValue('CookieConsent');
    if (!consents) {
      return false;
    }
    const preferencesConsent = decodeURIComponent(consents)
      .split(',')
      .find((value) => value.includes('preferences'));
    return !!preferencesConsent?.includes(':true');
  },

  setCookie: (name: string, value: string, expires: string = getDefaultExpirationDate(), params?: string) => {
    document.cookie = `${name}=${value}; expires=${expires}; domain=.telia.ee; path=/;${params}`;
  },

  setLanguageCookie: (value: string) => {
    const expirationDate = getDefaultExpirationDate();
    document.cookie = `${GUEST_LANGUAGE_COOKIE_NAME}=${value}; expires=${expirationDate}; domain=.telia.ee; path=/;`;
    document.cookie = `${GUEST_LANGUAGE_COOKIE_NAME}=${value}; expires=${expirationDate}; domain=.diil.ee; path=/;`;
  },
};

export default CookieApi;
